
export default {
  light: '#23272A',
  elevated: '#2E3539',
  sidebars: '#15191C',
  dark: '#24262d',

  middleblack: '#23272A',
  almostblack: '#202225',

  grey: '#72767D',

  text: '#dddddd',

  extra: '#dcddde',

  gold: '#ffeb7f',
  green: 'rgb(32, 134, 55)',
  red: '#ff7f7f',
  blue: '#7f7fff',
}

/*
export default {
  light: '#36393F',
  dark: '#2C2F33',

  middleblack: '#23272A',
  almostblack:'#202225',

  grey: '#72767D',

  text: 'white',

  extra: '#dcddde',

  gold: '#FFD569',
  green: '#43B581',
  red: '#FF4848',
  blue: '#337ab7'
}
*/
